import React from 'react'
import { Button } from 'antd'
import { PlayCircleOutlined } from '@ant-design/icons';

const InitialScreen = ({ onStart }) => {
    return (
        <>
            <div
                style={{
                    height: '100vh', // full viewport height
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#FFFFFF', // optional background
                    boxShadow: 'inset 0 0 100px rgba(0, 0, 0, 0.1)',
                }}
            >
                <Button
                    type="primary"
                    style={{
                        borderRadius: '25px',
                        padding: '12px 24px',
                        fontSize: '18px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    }}
                    size="large"
                    icon={<PlayCircleOutlined />}
                    onClick={onStart}> Start </Button>
            </div>
        </>
    )
}

export default InitialScreen
